import * as React from 'react';

import { useParams, useRouter } from 'js/lib/useRouter';

import { LoadingSection } from '@coursera/cds-core';

import { NotFound } from 'bundles/common/components/withNotFound';
import { useCourseReviewsPageData } from 'bundles/reviews/hooks/useCourseReviewsPageData';
import CourseReviewsPageContent from 'bundles/reviews/pages/course/CourseReviewsPageContent';
import type { ReviewRouter } from 'bundles/reviews/types/reviewTypes';
import { NotFoundError } from 'bundles/ssr/lib/errors/directives';
import inServerContext from 'bundles/ssr/util/inServerContext';

const CourseReviewsPageGuard = () => {
  const router = useRouter();
  const params = useParams();
  const slug = params?.slug ?? '';
  const programSlug = params?.programSlug;
  const orgSlug = params?.orgSlug;

  const { loading, error, reviewsPageData, schemaReviews } = useCourseReviewsPageData();

  if (loading) {
    return <LoadingSection />;
  }

  if (!slug || error || !reviewsPageData?.name) {
    if (inServerContext) {
      throw new NotFoundError();
    }
    return <NotFound />;
  }

  return (
    <CourseReviewsPageContent
      reviewsPageData={reviewsPageData}
      schemaReviews={schemaReviews}
      router={router as ReviewRouter}
      programSlug={programSlug}
      orgSlug={orgSlug}
    />
  );
};

export default CourseReviewsPageGuard;
